(function ($) {
  // Main big hero area slider / fader
  if ($("#hero_area__image_slider").length > 0) {
    //$('#hero_area__image_slider').slick();
    var slider_control = JSON.parse(
      $("#hero_area__image_slider").attr("data-slick")
    );
    var time_sec = slider_control.autoplaySpeed / 1000;
    var time = time_sec;
    var $bar, $slick, isPause, tick, percentTime;

    $slick = $("#hero_area__image_slider");
    $slick.slick({
      dotsClass: "slick-dots container-lg",
    });

    $bar = $(".slider-progress .progress");

    $(".slider-wrapper").on({
      mouseenter: function () {
        isPause = true;
      },
      mouseleave: function () {
        isPause = false;
      },
    });

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      isPause = false;
      tick = setInterval(interval, 10);
    }

    function interval() {
      if (isPause === false) {
        percentTime += 1 / (time + 0.1);
        $bar.css({
          width: percentTime + "%",
        });
        if (percentTime >= 100) {
          $slick.slick("slickNext");
          startProgressbar();
        }
      }
    }

    function resetProgressbar() {
      $bar.css({
        width: 0 + "%",
      });
      clearTimeout(tick);
    }

    startProgressbar();

    $(".slick-next, .slick-prev").click(function () {
      startProgressbar();
    });

    // $('.buttons .action').on('click', function() {
    $(document).on("click", ".action i", function () {
      if ($(this).hasClass("fa-play")) {
        $(this).addClass("fa-pause");
        $(this).removeClass("fa-play");
        startProgressbar();
        $("#hero_area__image_slider").slick("slickPlay");
      } else {
        $(this).removeClass("fa-pause");
        $(this).addClass("fa-play");
        isPause = true;
        $("#hero_area__image_slider").slick("slickPause");
      }
    });

    if ($("div").hasClass("slick-hero")) {
      var checkExist = setInterval(function () {
        if ($(".slick-dots").length) {
          // $('<div class="buttons"><button class="action play">Pause</button></div>').insertAfter('.slick-dots');
          clearInterval(checkExist);
          $(".slick-dots").append(
            '<li class="slider-action"><span class="action"><i class="fa fa-pause fa-xs" aria-hidden="true"></i></span></li>'
          );
        }
      }, 100);
    }
  }
  $(".VideoModal .transcriptData").click(function (e) {
    e.preventDefault();
    var parent_id = $(this).closest(".VideoModal").attr("id");
    $("#" + parent_id + " .paragraph-text").fadeToggle("slow", function () {
      if ($(this).is(":visible")) {
        $("#" + parent_id + " .transcriptData").html("Hide transcript");
      } else {
        $("#" + parent_id + " .transcriptData").html("View transcript");
      }
    });
  });
  $(".VideoModal .transcript-toggle").click(function (e) {
    e.preventDefault();
    var transcript_text = $(this).parent().find(".transcript-text");
    if (transcript_text.is(":visible")) {
      transcript_text.slideUp();
      $(this).html("View transcript");
    } else {
      transcript_text.slideDown();
      $(this).html("Hide transcript");
    }
  });

  $(".VideoModal .ytvideo .playbutton").on("click", function (e) {
    console.log("Modal clicked");
    $(this).parent().find("iframe").css("display", "block");
    $(this).css("display", "none");
    $(this).parent().css("background-image", "none");
    // $(this).parent().find("iframe")[0].src += "?autoplay=1";
    e.preventDefault();
  });

  /* Video Modal for YouTube behaves differently on production compared to staging or local development.
   * The src of the iframe is replaced with what seems to be a tracking pixel and the original video source is added to the data-src attribute.
   * The problem arises when playing the video once, closing the modal and re-opening it. The video doesn't show.
   * As a quick fix the data-src of YoTube iframes is set right away. Once the modal opens and closes the src attribute is toggled to
   * prevent the video from playing once the modal is closed.
   */

  var videoModalYouTubeIframes = document.querySelectorAll(
    ".VideoModal .ytvideo iframe"
  );
  videoModalYouTubeIframes.forEach(function (iframe) {
    var dataSrc = iframe.getAttribute("data-src");
    if (dataSrc) {
      iframe.src = dataSrc;
    } else {
      iframe.setAttribute("data-src", iframe.src);
    }
  });

  $(".VideoModal").on("shown.bs.modal", function (e) {
    var iframe = $(e.currentTarget).find(".ytvideo iframe")[0];
    var dataSrc = iframe.getAttribute("data-src");

    if (dataSrc) {
      iframe.src = dataSrc;
    }

    var target = e.currentTarget;
    $(target).find("iframe").css("display", "block");
    $(target).find(".ytvideo .playbutton").css("display", "none");
    $(target).css("background-image", "none");
  });

  $(".VideoModal").on("hidden.bs.modal", function (e) {
    var videos = document.querySelectorAll("iframe, video");
    Array.prototype.forEach.call(videos, function (video) {
      if (video.tagName.toLowerCase() === "video") {
        video.pause();
      } else {
        var iframe = $(e.currentTarget).find(".ytvideo iframe")[0];
        var dataSrc = iframe.getAttribute("data-src");

        if (dataSrc) {
          iframe.src = "";
        }
      }
    });
  });

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    verticalSwiping: true,
    vertical: true,
    // prevArrow: '<button class="slide-arrow slick-prev"><span aria-label="Previous"><</span></button>',
    // nextArrow: '<button class="slide-arrow slick-next"><span aria-label="Next">></span></button>',

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          vertical: false,
          verticalSwiping: false,
          adaptiveHeight: true,
          prevArrow:
            '<button class="slide-arrow slick-prev"><span aria-label="Previous"><</span></button>',
          nextArrow:
            '<button class="slide-arrow slick-next"><span aria-label="Next">></span></button>',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          vertical: false,
          verticalSwiping: false,
          adaptiveHeight: true,
          prevArrow:
            '<button class="slide-arrow slick-prev"><span aria-label="Previous"><</span></button>',
          nextArrow:
            '<button class="slide-arrow slick-next"><span aria-label="Next">></span></button>',
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $("a[data-slide]").click(function (e) {
    e.preventDefault();
    var slideno = $(this).data("slide");
    $(".slider-nav").slick("slickGoTo", slideno - 1);
  });
  $(".owl-carousel").owlCarousel({
    loop: false,
    responsiveClass: true,

    responsive: {
      0: {
        items: 1,
        dotsEach: true,
        nav: true,
        dots: true,
      },
      768: {
        items: 3,
        nav: true,
        dotsEach: true,
        dots: true,
      },
      1000: {
        items: 3,
        nav: false,
        dotsEach: false,
        loop: false,
        dots: false,
      },
    },
  });

  $("#searchResultOrder").change(function () {
    var url = $(this).find("option:selected").val();

    //if(url.indexOf("http://") == 0){
    window.location = $(this).find("option:selected").val();
    // }
  });
  /* // Create the dropdown base
   $("<select />").appendTo("#roadsafetyleft-sidebar nav");

   // Create default option "Go to..."
   $("<option />", {
   "selected": "selected",
   "value"   : "",
   "text"    : "Go to..."
   }).appendTo("#roadsafetyleft-sidebar nav select");

   // Populate dropdown with menu items
   $("#roadsafetyleft-sidebar nav a").each(function() {
   var el = $(this);
   $("<option />", {
       "value"   : el.attr("href"),
       "text"    : el.text()
   }).appendTo("#roadsafetyleft-sidebar nav select");
   });

   $("#roadsafetyleft-sidebar nav select").change(function() {
       window.location = $(this).find("option:selected").val();
     }); */
  $("#roadsafetyleft-sidebar nav select").change(function () {
    var url = $(this).find("option:selected").val();
    //console.log(url.indexOf("http://"));
    if (url.indexOf("http://") == 0) {
      window.location = $(this).find("option:selected").val();
    } else {
      $("html,body").animate(
        {
          scrollTop: $(url).next().offset().top,
        },
        "slow"
      );
    }
  });
  $("#roadsafetyleft-sidebar nav ul li ul li a").click(function () {
    var url = $(this).attr("href");
    if ($(window).width() < 768) {
      //console.log(11);
      jQuery("#leftside-navbar").addClass("fixed").removeAttr("style");
      $("html,body").animate(
        {
          scrollTop: $(url).next().offset().top - 140,
        },
        "slow"
      );
    } else {
      $("html,body").animate(
        {
          scrollTop: $(url).next().offset().top,
        },
        "slow"
      );
    }
  });
  $("#roadsafetyleft-sidebar nav ul li ul").on("click", "li", function () {
    $("#roadsafetyleft-sidebar nav ul li ul li.active").removeClass("active");
    $(this).addClass("active");
  });
  $("#initiative-left-sidebar ul li ul").on(
    "click",
    ".filter-button",
    function () {
      $("#initiative-left-sidebar ul li ul .filter-button.active").removeClass(
        "active"
      );
      $(this).addClass("active");
    }
  );
  $("#share-btn").on("click", function (e) {
    $(".social-sticky .social").toggleClass("hideShowSocials");
    // $(".social-sticky .social").slideToggle("fast", "linear");
  });

  /* on scroll sticky sidebar */
  /* Commented out the code, because it was throwing errors and not functioning. The stickyness is set via css. */

  // if ($("#leftside-navbar").length > 0) {
  //   if ($(window).width() > 768) {
  //     jQuery(function () {
  //       var top =
  //         jQuery("#leftside-navbar").offset().top -
  //         parseFloat(
  //           jQuery("#leftside-navbar").css("marginTop").replace(/auto/, 0)
  //         );
  //       var footTop =
  //         jQuery(".bgcolor").offset().top -
  //         parseFloat(
  //           jQuery("#wrapper-footer").css("marginTop").replace(/auto/, 0)
  //         );

  //       var maxY = footTop - jQuery("#leftside-navbar").outerHeight();

  //       jQuery(window).scroll(function (evt) {
  //         var y = jQuery(this).scrollTop();
  //         if (y > top) {
  //           //Quand scroll, ajoute une classe ".fixed" et supprime le Css existant
  //           if (y < maxY) {
  //             jQuery("#leftside-navbar").addClass("fixed").removeAttr("style");
  //           } else {
  //             //Quand la sidebar arrive au footer, supprime la classe "fixed" précèdement ajouté
  //             jQuery("#leftside-navbar")
  //               .removeClass("fixed")
  //               .css({
  //                 position: "sticky",
  //                 top: maxY - top + "px",
  //               });
  //           }
  //         } else {
  //           // jQuery('#leftside-navbar').removeClass('fixed');
  //         }
  //       });
  //     });
  //   }

  //   if ($(window).width() < 767) {
  //     jQuery(function () {
  //       var top =
  //         jQuery("#leftside-navbar").offset().top -
  //         parseFloat(
  //           jQuery("#leftside-navbar").css("marginTop").replace(/auto/, 0)
  //         );
  //       var footTop =
  //         jQuery(".bgcolor").offset().top -
  //         parseFloat(
  //           jQuery("#wrapper-footer").css("marginTop").replace(/auto/, 0)
  //         );

  //       var maxY = footTop - jQuery("#leftside-navbar").outerHeight();

  //       jQuery(window).scroll(function (evt) {
  //         var y = jQuery(this).scrollTop();

  //         if (top - y < 140) {
  //           //Quand scroll, ajoute une classe ".fixed" et supprime le Css existant
  //           if (y < maxY) {
  //             jQuery("#leftside-navbar").addClass("fixed").removeAttr("style");
  //           }
  //         } else {
  //           jQuery("#leftside-navbar").removeClass("fixed");
  //         }
  //       });
  //     });
  //   }
  // }

  /* on scroll sticky mobile header */
  $(window).on("scroll", function () {
    // var scroll = $(window).scrollTop();
    var sticky = document.getElementsByClassName("second-logo")[1].offsetTop;

    //>=, not <=
    if (window.pageYOffset > sticky) {
      //clearHeader, not clearheader - caps H
      $(
        ".mobile-header .navbar-toggler ,.mobile-header .second-logo,.mobile-header"
      ).addClass("fixed");
    } else {
      $(
        ".mobile-header .navbar-toggler ,.mobile-header .second-logo,.mobile-header"
      ).removeClass("fixed");
    }
  });

  $("#contact-form").validate({
    rules: {
      FirstName: {
        required: true,
      },
      LastName: {
        required: true,
      },
      Email: {
        required: true,
        email: true,
      },
      t_and_c: {
        required: true,
      },
    },
    messages: {
      FirstName: {
        required: "Please enter your first name.",
      },
      LastName: {
        required: "Please enter your last name.",
      },
      Email: {
        required: "Please enter a valid email address.",
      },
      t_and_c: {
        required: "Please Select Privacy Policy.",
      },
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") == "t_and_c") {
        error.insertAfter(".t_and_c");
      } else {
        error.insertAfter(element);
      }
    },
  });

  // Check if a campaign exists and if there are no campaigns
  // don't show it on the sidebar
  if ($(".initiatives-sidebar li .filter-button")) {
    $(".initiatives-sidebar li .filter-button").each(function () {
      var value = $(this).data("filter");
      if ($("." + value).length > 0) {
        $($(this)).parent().show();
      } else {
        $($(this)).parent().hide();
      }
    });
  }

  // Hub pages - If there are no campaigns related to that hub,
  // do not display campaigns sidebar title.

  $.get("/campaigns/", function (data) {
    // get existing campaign titles from /campaigns page
    var campaignTitles = $(data).find(".ini-card label.hub-name").get();

    var titles = [];

    // create an array containing campaign titles
    campaignTitles.forEach((element) => {
      var title = element.innerText.trim().toLowerCase();

      title = title.replace("&", "-");

      if (titles.includes(title)) {
        return;
      } else {
        titles.push(title);
      }

      return titles;
    });

    // check if the current hub has a campaign
    // if($('#leftside-navbar')) {
    //   var pageTitle = $.trim($('#leftside-navbar .h6 a').html())
    //   pageTitle = pageTitle.toLowerCase();
    //   pageTitle = pageTitle.replace("&amp;", "-")

    //   if(titles.includes(pageTitle)) {
    //     $('.btn-campaign-filter').show()
    //   } else {
    //     $('.btn-campaign-filter').parent().hide()
    //   }
    // }
  });

  $(".filter-button").click(function (e) {
    e.preventDefault();
    var value = $(this).attr("data-filter");
    var label = $(this).attr("data-filter-label");
    if (value == "all") {
      $(".filter").show("1000");
      $(
        "#initiative-left-sidebar nav ul li ul li.filter-button.active"
      ).removeClass("active");
      $(".filter-title").show("1000");
      $(".filter-subtitle").hide("1000");
      $(".road-safety-hubs, .road-user-hubs").css("background-color", "#fff");
    } else {
      $(".filter")
        .not("." + value)
        .hide("3000");
      $(".filter")
        .filter("." + value)
        .show("3000");
      $(".filter-title").hide("1000");
      $(".filter-subtitle").hide("1000");
      $(".filter")
        .filter("." + value)
        .parent()
        .prev()
        .find(".filtered-title")
        .removeClass("d-none")
        .html(label);
      $(".filter")
        .filter("." + value)
        .parent()
        .prev()
        .find(".filtered-title")
        .addClass("mt-3");
      $(".filter")
        .filter("." + value)
        .parent()
        .prev()
        .show("1000");
      $(".road-safety-hubs, .road-user-hubs").css("background-color", "#fff");
    }
  });

  $(".tool-page .filter-button").click(function () {
    var value = $(this).children().attr("href");
    window.location = value;
  });

  if ($(".tool-page").length > 0) {
    var filterButton = $(
      ".initiatives-page #initiative-left-sidebar nav li.filter-button"
    );
    if (filterButton.hasClass("active")) {
      var activeFilter = filterButton.filter(".active");
      $(activeFilter).parent().css("background-color", "#f2f2f2");
    }
  }

  $(".btn-campaign-filter").click(function () {
    localStorage.setItem("campaign-filter", $(this).data("campaign-filter"));
  });

  $(".navbar-nav .nav-link").click(function () {
    localStorage.setItem("campaign-filter", "");
  });

  if (localStorage.getItem("campaign-filter")) {
    $(
      '*[data-filter-label="' + localStorage.getItem("campaign-filter") + '"]'
    ).click();
  }
})(jQuery);
